import { render, staticRenderFns } from "./branchDetails.vue?vue&type=template&id=4c5daa25&"
import script from "./branchDetails.vue?vue&type=script&lang=js&"
export * from "./branchDetails.vue?vue&type=script&lang=js&"
import style0 from "./branchDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports